import { render } from "./WineTasting.vue?vue&type=template&id=12dbcf7a&scoped=true"
import script from "./WineTasting.vue?vue&type=script&lang=js"
export * from "./WineTasting.vue?vue&type=script&lang=js"

import "@/assets/css/user/common.css?vue&type=style&index=0&id=12dbcf7a&scoped=true&lang=css"
import "@/assets/css/user/dark/common-dark.css?vue&type=style&index=1&id=12dbcf7a&scoped=true&lang=css"
import "./WineTasting.vue?vue&type=style&index=2&id=12dbcf7a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shcho\\Desktop\\home\\git\\test\\cloudpos.kiosk\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12dbcf7a"]])

export default __exports__